<div class="po-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Generate purchase orders</h2>
    <button mat-icon-button type="button" (click)="close()"><mat-icon>close</mat-icon></button>
  </div>

  <mat-dialog-content>
    <div *ngIf="loading" class="state">
      <mat-spinner diameter="36"></mat-spinner>
      <p>Loading L1 / L2 / L3 quotes…</p>
    </div>

    <div *ngIf="!loading && error" class="state error">{{ error }}</div>

    <ng-container *ngIf="!loading && !error">
      <p class="hint">
        {{ invitation?.project_name }} · {{ invitation?.boq_code }}
        Items default to L1. Reassign a line to L2 or L3 to split the order.
      </p>

      <div class="rank-chips">
        <div class="rank-chip" *ngFor="let rank of rankOrder">
          <strong>{{ rank }}</strong>
          <span>{{ ranks[rank]?.org_name }}</span>
          <span class="muted">{{ formatCurrency(ranks[rank]?.bid_amount) }}</span>
        </div>
      </div>

      <p class="existing" *ngIf="existingPos.length">
        Existing POs will be updated:
        <span *ngFor="let po of existingPos; let last = last">
          {{ po.po_ref }} ({{ po.vendor_name }})<span *ngIf="!last">, </span>
        </span>
      </p>

      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Unit</th>
              <th *ngFor="let rank of rankOrder">{{ rank }} amount</th>
              <th>Assign to</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>
                <div class="item-code">{{ item.item_code || ('#' + item.item_id) }}</div>
                <div class="item-desc">{{ item.item_description }}</div>
              </td>
              <td>{{ item.unit || '—' }}</td>
              <td *ngFor="let rank of rankOrder">
                {{ item.quotes?.[rank] ? formatCurrency(item.quotes[rank].amount) : '—' }}
              </td>
              <td>
                <select class="rank-select" [(ngModel)]="item.assigned_rank">
                  <option *ngFor="let rank of rankOrder" [ngValue]="rank">
                    {{ rank }} · {{ ranks[rank]?.org_name }}
                  </option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="totals" *ngIf="vendorTotals().length">
        <div class="total-card" *ngFor="let row of vendorTotals()">
          <strong>{{ row.rank }} · {{ row.org_name }}</strong>
          <span>{{ row.count }} item{{ row.count === 1 ? '' : 's' }}</span>
          <span>{{ formatCurrency(row.total) }}</span>
        </div>
      </div>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="onGenerate()"
      [disabled]="loading || submitting || !!error || !items.length"
    >
      {{ submitting ? 'Generating…' : 'Generate PO' }}
    </button>
  </mat-dialog-actions>
</div>
